export default "__VITE_ASSET__YoL1fOVB__"